import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';

import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';
import { StateService } from 'app/core/state.service';
import { Email } from '../pages/checkit-dashboard/checkit.model';



@Injectable()
export class EmailService {

    readonly api = `${environment.functionsURL}/app`;

    constructor(private http: HttpClient, private afAuth: AngularFireAuth, private afs: AngularFirestore, private state: StateService) {
    }

    // Email Invitation
    sentmail(email_to_post: any): Observable<Email> {
        const url = `${this.api}/sentmail`;
        return this.http.post<Email>(url, { email_to_post });
    }
    updateRsvp(code): Observable<any> {
        const url = `${environment.functionsURL}/rsvp`;
        return this.http.post<any>(url, { code });
    }


}



// WEBPACK FOOTER //
// ./src/app/core/email.service.ts